angular.module('unica_campaign_template.campaign_template_controllers')

.controller('CampaignTemplateCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	CampaignTemplateCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$scope.tinymceOptionsReady = false;

	$scope.tinymceOptionsEmailSubjectCampaign = angular.copy($rootScope.tinymceOptionsEmailSubject);
	$scope.tinymceOptionsEmailBodyCampaign = angular.copy($rootScope.tinymceOptionsEmailBody);

	$scope.attachmentTags = [];

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventTags( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );


	$scope.$on( 'event_tag_loaded', function() {

		var tinymceValues = [
			{ text: 'Nome', value: '{FIRST_NAME}' },
			{ text: 'Cognome', value: '{LAST_NAME}' },
			{ text: 'Data Tappa Da', value: '{FIRST_STAGE_DAY_FROM}' },
			{ text: 'Data Tappa A', value: '{FIRST_STAGE_DAY_TO}' },
			{ text: 'Orario Tappa Da', value: '{FIRST_STAGE_TIME_FROM}' },
			{ text: 'Orario Tappa A', value: '{FIRST_STAGE_TIME_TO}' },
			{ text: 'Nome Location', value: '{LOCATION_NAME}' },
			{ text: 'Indirizzo Location', value: '{LOCATION_ADDRESS}' },
			{ text: 'Nome Agenzia', value: '{AGENCY_NAME}' },
		];

		angular.forEach($rootScope.eventTagData, function(tag, key) {
			if ( tag.type === 'text' ) {
				var value = tag.tag.toLowerCase();
				value = value.replace(' ', '_');
				value = value.replace('à', 'a');
				value = value.replace('è', 'e');
				value = value.replace('é', 'e');
				value = value.replace('ì', 'i');
				value = value.replace('ò', 'o');
				value = value.replace('ù', 'u');
				value = value.replace(/[^a-zA-Z0-9]/g, '_');
				value = value.toUpperCase();

				tinymceValues.push({text: tag.tag, value: '{' + value + '}'});
			} else if ( tag.type === 'attachment' ) {
				$scope.attachmentTags.push( {text: tag.tag, value: 'tag_' + tag.id, state: false } );
				console.log($scope.attachmentTags);
			}
		});

		$scope.tinymceOptionsEmailSubjectCampaign.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});
		};

		$scope.tinymceOptionsEmailBodyCampaign.setup = function (editor) {
			editor.addButton('placeholder_btn', {
				type: 'listbox',
				text: 'Placeholders Email',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: tinymceValues,
				onPostRender: function () {
				}
			});

			editor.addButton('sections_btn', {
				type: 'listbox',
				text: 'Placeholders Sezioni',
				icon: false,
				onselect: function (e) {
					editor.insertContent(this.value());
				},
				values: [
					{ text: 'Pulsante Azione', value: '{{UNICA_ACTION_CTA}}' },
					{ text: 'Sezione Hotel', value: '{{UNICA_ROOM_DATA}}' },
					{ text: 'Sezione Transfer', value: '{{UNICA_TRANSFER_DATA}}' },
					{ text: 'Sezione Dati Registrazione', value: '{{UNICA_REGISTRATION_DATA}}' },
					{ text: 'Sezione Credenziali', value: '{{UNICA_PASSWORD_DATA}}' },
				],
				onPostRender: function () {
				}
			});
		};


		$scope.tinymceOptionsReady = true;

	});

	$rootScope.getServicesUsers();

	$scope.resetCampaignTemplateData();

	$scope.saveCampaignTemplate = function()
	{
		$scope.showLoader();

		var campaignTemplateData = angular.copy($scope.campaignTemplateData);

		campaignTemplateData.logo  = ( $scope.campaignTemplateData.logo  && $scope.campaignTemplateData.logo.dataURL  ? $scope.campaignTemplateData.logo.dataURL : '' );
		campaignTemplateData.cover = ( $scope.campaignTemplateData.cover && $scope.campaignTemplateData.cover.dataURL ? $scope.campaignTemplateData.cover.dataURL : '' );
		campaignTemplateData.image = ( $scope.campaignTemplateData.image && $scope.campaignTemplateData.image.dataURL ? $scope.campaignTemplateData.image.dataURL : '' );

		campaignTemplateData.include_attachment_tags = [];

		angular.forEach($scope.attachmentTags, function(attachmentTag, key) {
			if ( attachmentTag.state ) {
				campaignTemplateData.include_attachment_tags.push(attachmentTag.value);
			}
		});

		campaignTemplateData.include_attachment_tags = campaignTemplateData.include_attachment_tags.join(',');

		// campaignTemplateData.attachmentTags = [];

		// angular.forEach($scope.attachmentTags, function(attachmentTag, key) {
		// 	if ( attachmentTag.state ) {
		// 		campaignTemplateData.attachmentTags.push(attachmentTag.id);
		// 	}
		// });


		CampaignTemplateCreateService
			.create( $stateParams.event_id, campaignTemplateData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Template Campagna creato con successo!', '');

					$state.go('app.campaign_template.edit', { event_id: $stateParams.event_id, id: data.id });
				}
			});
	};

});


